import { makeStyles } from '@material-ui/core/styles';
import { alpha } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
    verifySectionCompactBottom: {
        marginBottom: theme.spacing(-3),
    },
    verifyButtonContainerWrapper: {
        display: 'flex',
        gap: theme.spacing(3),
    },
    verifyButtonContainer: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(3),
    },
    verifyTestResults: {
        marginTop: theme.spacing(2),
        paddingRight: theme.spacing(3),
        position: 'relative',
    },
    verifyTestResult: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionRow,
        padding: theme.spacing(1),
    },
    verifyTestResultTitle: {
        paddingTop: theme.spacing(0.25),
        fontWeight: 500,
        lineHeight: '21px',
    },
    verifyTestResultStatus: {
        fontStyle: 'italic',
    },
    verifyTestResultText: {
        fontSize: '1rem',
    },
    resultFail: {
        backgroundColor: alpha(theme.palette.status.red, 0.1),
        '& svg': {
            marginRight: theme.spacing(2),
            color: theme.palette.status.red,
        },
    },
    resultUnknown: {
        backgroundColor: alpha(theme.palette.status.gray, 0.1),
        '& svg': {
            marginRight: theme.spacing(2),
            color: theme.palette.status.gray,
        },
    },
    resultSuccess: {
        backgroundColor: alpha(theme.palette.status.green, 0.1),
        '& svg': {
            marginRight: theme.spacing(2),
            color: theme.palette.status.green,
        },
    },
    userInfoContainer: {
        marginLeft: theme.spacing(3),
        marginTop: theme.spacing(1),
        paddingBottom: theme.spacing(2),
        overflowX: 'auto',
        width: '97%',
    },
}));
